import React from 'react';
import { Tooltip } from 'reactstrap';
import { connect } from "react-redux";
import moment from 'moment';
import { getTimeZone, isCentralTimeZone, getCentralDateWithFormat } from '../../../helpers/Tools';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi"; 

class ReviewAndSubmit extends React.Component {
    constructor() {
        super();
        this.state = {
            tooltipOpen: false
        };
    } 
    
    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisit.ReviewSubmit.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    isValid() {
        return true;
    }

    onGoNext = () => {
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
        logUI("MBHWeb.UI.VideoVisit.ReviewSubmit.Submit", new Date(), Tools.getURLPath());
    }
    toggleToolTip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }
    render() {
        const { tooltipOpen } = this.state;
        const { name, price, videoVisitRequest, enableVirtualDashboardUpdates, timezone, showTimeZoneMessage} = this.props;
        const dateTimeInUTC = videoVisitRequest && videoVisitRequest.timeSlot && videoVisitRequest.timeSlot.dateTimeInUtc ? videoVisitRequest.timeSlot.dateTimeInUtc : "";
        const dateTimeInDallas = videoVisitRequest && videoVisitRequest.timeSlot && videoVisitRequest.timeSlot.dateTimeInDallas ? videoVisitRequest.timeSlot.dateTimeInDallas : "";
        const utcDateTime = moment.utc(dateTimeInUTC).local().format("MMM DD  -  h:mm a").toUpperCase();
        const centralDateTime = moment(dateTimeInDallas).format("MMM DD  -  h:mm a").toUpperCase();
        const dateTime = showTimeZoneMessage ? centralDateTime : utcDateTime;
        
        return (
            <div className="row review-submission-container" style={this.props.style}>
                <div className="col-12">
                    <div className="review-step__icon"><div className="svg-coffee" /></div>
                    <h1 className="step-heading step-heading-md">Confirm your appointment details.</h1>
                </div>
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <h2 className="h5">Patient</h2>
                            <div className="review-details">
                                {name}
                            </div>
                            <div className="hr-divider" />
                        </div>
                        <div className="col-12 col-md-6">
                            <h2 className="h5">Provider</h2>
                            <div className="review-edit-btn">
                                <button type="button" className="btn btn-icon-only" onClick={(e) => null}>
                                    <span className="icon-question" id="tooltip-info-provider" />
                                    <Tooltip innerClassName="text-center tooltip-innertext" placement="top" isOpen={tooltipOpen} autohide={false} target="tooltip-info-provider" toggle={this.toggleToolTip}>
                                        Connect with an On-Call Baylor Scott & White Health board certified provider, who will 
                                        evaluate your condition and complete documentation within your MyBSWHealth medical record. <b>Please note this will not be with your existing care team</b>. 
                                    </Tooltip>
                                </button>
                            </div>
                            <div className="review-details">
                                Baylor Scott & White Provider
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <h2 className="h5">Reason for Visit</h2>
                            <div className="review-details">
                                {videoVisitRequest.condition}
                            </div>
                            <div className="hr-divider" />
                        </div>
                        <div className="col-12 col-md-6">
                            <h2 className="h5">Cost</h2>
                            <div className="review-details">
                                {`${price}`}
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h2 className="h5">Time & Day</h2>
                            <div className="review-details">
                                {dateTime} {showTimeZoneMessage ? timezone : getTimeZone()}
                            </div>
                            <div className="hr-divider" />
                        </div>
                    </div> 
                    <div className="row">
                        <div className="col-12">
                            {enableVirtualDashboardUpdates?
                                <div className="term-agree-note">*By proceeding, I accept financial responsibility and agree to pay the above listed amount. I understand that this service is only covered by certain insurance plans and that I may not be able to have my health insurance provider reimburse this cost. Further, should my insurance provider not offer reimbursement for this service, I am electing to pay this amount out of pocket and I am directing BSWH not to share any information about this visit with my health insurance provider.</div>
                                :
                                <div className="term-agree-note">*By proceeding, I accept financial responsibility and agree to pay the above listed amount. I understand that high deductible plan costs may vary until the deductible is met.</div>
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    const enableVirtualDashboardUpdates = state.session.serverData && state.session.serverData.enableVirtualDashboardUpdates;
    return {
        name: state.memberships.currentUser ? state.memberships.currentUser.displayName : "",
        price: state.memberships.SDCCostLabel,
        enableVirtualDashboardUpdates
    };
};
export default connect(mapStateToProps, null, null, {withRef: true})(ReviewAndSubmit);